export function formatAmount(amount, currency = undefined) {
  if (currency) {
    const formater = new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: currency,
      currencyDisplay: "symbol",
    });
    return formater.format(amount);
  } else {
    const formater = new Intl.NumberFormat("fr-FR");
    return formater.format(amount) ;
  }

}

export default {
  formatAmount,
};
